<template>
  <div class="text-dark-600 flex items-center justify-between w-full cursor-pointer">
    <div
      class="flex items-center rounded-8 w-130 h-32 px-5 mr-10 border-3 border-transparent"
      :style="`background-color: ${color}`"
      :class="{ 'tag-border': isSelected }"
    >
      <div v-if="!isEdit" class="w-full h-full text-14 flex items-center lowercase" @click="toggleTag">
        <p v-if="!!tag.name" class="text-16">#</p>
        {{ tag.name }}
      </div>
      <div v-else class="flex items-center">
        <p class="text-16">#</p>
        <input
          ref="inputRef"
          v-model="name"
          class="w-full rounded text-14 bg-transparent outline-none lowercase"
          maxlength="10"
          type="text"
          @blur="onBlur"
          @keypress.space.prevent
          @keypress.enter="onBlur"
        >
      </div>
    </div>
    <ButtonModule
      :has-hover="true"
      prefix="icon-edit text-15"
      class="top-0 bottom-0 right-0 p-0"
      @click="toggleEditMode"
    />
  </div>
</template>

<script>
import { computed, defineComponent, nextTick, ref } from 'vue'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default defineComponent({
  components: { ButtonModule },

  props: {
    tag: Object,
    isSelected: Boolean
  },

  emits: ['toggleTag', 'updateTag'],

  setup (props, { emit }) {
    const inputRef = ref(null)

    const name = ref(props.tag.name || '')
    const tempName = ref(props.tag.name || '')
    const isEdit = ref(false)

    const color = computed(() => `#${props.tag.color.toString(16)}`)

    function toggleEditMode () {
      isEdit.value = !isEdit.value
      nextTick(() => {
        inputRef.value.focus()
      })
    }

    function edit () {
      if (tempName.value.trim() !== name.value.trim()) {
        tempName.value = name.value
        emit('updateTag', { name: name.value, id: props.tag.id })
      }
    }

    function onBlur () {
      isEdit.value = false
      edit()
    }

    function toggleTag () {
      emit('toggleTag', {
        tag: props.tag,
        isSelected: props.isSelected
      })
    }

    return {
      // ref
      inputRef,
      // data
      name,
      isEdit,
      // computed
      color,
      // function
      toggleEditMode,
      toggleTag,
      onBlur
    }
  }
})
</script>

<style>
.tag-border {
  border: 3px solid rgba(0,0,0,0.3);
}
</style>
